import { render, staticRenderFns } from "./Subjects.html?vue&type=template&id=a4b5dec0&external"
import script from "./Subjects.js?vue&type=script&lang=js&external"
export * from "./Subjects.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports